import {
  IEditBriefInfluencersParams,
  IParseEditCreatorsGoogleSheetRequest,
} from "@shared/lib/types/brief";
import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";
import { getCustomColumnName } from "../../../lib/constants";

export function isProcessedEditRow(
  row: IParseEditCreatorsGoogleSheetRequest
): boolean {
  return row.status === "success" && Boolean(row.briefInfluencerId);
}

export function toEditBriefInfluencerParams(
  row: IParseEditCreatorsGoogleSheetRequest
): IEditBriefInfluencersParams {
  return {
    briefInfluencerId: row.briefInfluencerId,
    editDeliverablesV2Id: row.editDeliverablesV2Id,
    editedDataFields: row.editedDataFields,
    brandCost: row.brandCost,
    influencerCost: row.influencerCost,
  };
}

export function getEditExtraFieldEntries(
  row: IParseEditCreatorsGoogleSheetRequest,
  customFields: IFieldConfig[] = []
): { key: string; value: string }[] {
  return Object.entries(row.editedDataFields ?? {}).map(([key, value]) => ({
    key: getCustomColumnName(key, customFields),
    value: String(value),
  }));
}
